import React from "react";
import logoLoading from "../../images/logo_loading.gif";
import { delay } from "../../utils";

interface FileImageProps {
    file?: File | Blob | null;
    src?: string | null;
    height?: number;
    width?: number;
    className?: string;
    noImageSrc?: string;
}

interface FileImageState {
    url?: string;
}

export default class FileImage extends React.Component<FileImageProps, FileImageState>{

    constructor(props: FileImageProps) {
        super(props);
        this.state = {
            url: logoLoading
        };
        this.onError = this.onError.bind(this);
    }

    setUrl() {
        const { file, src, noImageSrc } = this.props;
        const { url } = this.state;

        if (url && !url.startsWith('http')) {
            URL.revokeObjectURL(url);
        }

        var urlNew = noImageSrc;

        if (file) {
            urlNew = URL.createObjectURL(file);
        } else if (src) {
            urlNew = src;
        }

        this.setState({ url: urlNew });
    }

    async componentDidMount() {
        await delay(500);
        this.setUrl();
    }

    componentWillUnmount() {
        const { url } = this.state;
        if (url && !url.startsWith('http')) {
            URL.revokeObjectURL(url);
        }
    }

    onError() {
        const { noImageSrc } = this.props;
        this.setState({ url: noImageSrc });
    }

    componentDidUpdate(prevProps: FileImageProps) {
        if (this.props.file !== prevProps.file || this.props.src !== prevProps.src) {
            this.setUrl();
        }
    }

    render() {
        const { url } = this.state;
        const { height, width, className } = this.props;

        return <img src={url} height={height} width={width} className={className} onError={this.onError} />;
    }

}